<template>
    <div class="forms-feature__error-message-block" v-if="ServerErrormessages.length > 0">
        <ul>
            <li v-for="(err, index) in ServerErrormessages" :key="index">{{Strings[err.TextKey]}}</li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'Strings',
                'ServerErrormessages'
            ])
        }
    };
</script>